<style scoped>
    .social-button {
        height: 1.5em;
        width: 1.5em;
    }
</style>

<template>
    <v-list>
        <div>
            <v-btn v-for="item in socialItems()" :key="item.icon" class="v-btn v-btn--icon"
                @click="openLink(item.link)">
                <font-awesome-icon dark :icon="{ prefix: 'fab', iconName: item.icon }" class="social-button" />
            </v-btn>
        </div>
    </v-list>
</template>

<script>
import { getSocialLinks } from '../utils/menubuilder'

export default {
    name: 'social',
    data () {
        return {
            items: []
        }
    },
    methods: {
        socialItems() {
            var _items = getSocialLinks();
            return _items;
        },
        openLink(link) {
            window.open(link, '_blank');
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/Social.vue